// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"1f339ac0","87":"ba260aa4","146":"77af0f9b","158":"97f94597","168":"272f78c7","318":"cfd3483e","346":"0b23f1c7","377":"c7333f12"}[chunkId] + ".chunk.css";
};